//
// ops-routing.js
//
// Copyright (c) 2015 by Curalate, Inc.
//
/* global angular:false */
((() => {
    angular.module('curalate').config(['$routeProvider',
        ($routeProvider) => {
            $routeProvider.
                when('/v1/products/', {
                    templateUrl: '/app/components/products/main/products.html',
                    controller: 'ProductsController',
                }).
                when('/v1/products/stats/', {
                    templateUrl: '/app/components/products/main/stats.html',
                }).
                otherwise({
                    redirectTo: '/v1/products/',
                });
        },
    ]);
}))();
